/**
 * The history of the trainer's conversations with Buddy: the read behind the module's rail.
 *
 * Newest first, a page at a time under a keyset cursor (`before`); the rail asks for the next page
 * as it is scrolled to its end. `total` rides on every page.
 */

import { infiniteQueryOptions, type QueryClient } from '@tanstack/react-query';

import { getAiConversationsHistory } from '~/shared/api/generated/endpoints/ai/ai';

/** A page of the rail: twenty rows fill the column at any supported height with room to scroll. */
const PAGE_SIZE = 20;

export const aiHistoryQueryKey = ['ai', 'history'] as const;

export function aiHistoryQueryOptions() {
  return infiniteQueryOptions({
    queryKey: aiHistoryQueryKey,
    queryFn: ({ pageParam, signal }) =>
      getAiConversationsHistory(
        { limit: PAGE_SIZE, ...(pageParam === null ? {} : { before: pageParam }) },
        undefined,
        signal,
      ),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextBefore ?? null,
  });
}

/** The history changed: a conversation began, moved on, was saved as a program, or was deleted. */
export function invalidateAiHistory(client: QueryClient): Promise<void> {
  return client.invalidateQueries({ queryKey: aiHistoryQueryKey });
}
